export type EtsyOrderSummary = {
  receiptId: string
  status?: string | null
  createdAt?: number | string | null
  buyerName?: string | null
  total?: number | null
  currency?: string | null
  itemCount?: number | null
}

export type EtsyOrdersResponse = {
  orders: EtsyOrderSummary[]
  currentPage: number
  lastPage: number
  total: number
  perPage: number
}

export type EtsyOrderItem = {
  title: string
  quantity?: number | null
  price?: number | null
  currency?: string | null
}

export type EtsyOrderDetailResponse = {
  order: {
    receiptId: string
    status?: string | null
    createdAt?: number | string | null
    buyerName?: string | null
    total?: number | null
    currency?: string | null
  }
  items: EtsyOrderItem[]
}

function etsyErrorMessage(data: unknown, fallback: string): string {
  if (
    data &&
    typeof data === 'object' &&
    'message' in data &&
    typeof (data as { message: unknown }).message === 'string'
  ) {
    return (data as { message: string }).message
  }
  return fallback
}

export async function getEtsyOrders(
  brandId: string,
  shopId: string,
  page = 1,
  limit = 25,
): Promise<EtsyOrdersResponse> {
  const q = new URLSearchParams({
    brandId,
    shopId,
    page: String(page),
    limit: String(limit),
  })
  const res = await fetch(`/api/etsy/orders?${q.toString()}`)
  const data = await res.json()
  if (!res.ok || data?.error) throw new Error(etsyErrorMessage(data, `HTTP ${res.status}`))
  return {
    orders: Array.isArray(data?.orders) ? data.orders : [],
    currentPage: data?.currentPage ?? page,
    lastPage: data?.lastPage ?? 1,
    total: data?.total ?? (Array.isArray(data?.orders) ? data.orders.length : 0),
    perPage: data?.perPage ?? limit,
  }
}

export async function getEtsyOrder(
  brandId: string,
  shopId: string,
  receiptId: string,
): Promise<EtsyOrderDetailResponse> {
  const q = new URLSearchParams({
    brandId,
    shopId,
    receiptId,
  })
  const res = await fetch(`/api/etsy/order?${q.toString()}`)
  const data = await res.json()
  if (!res.ok || data?.error) throw new Error(etsyErrorMessage(data, `HTTP ${res.status}`))
  return data as EtsyOrderDetailResponse
}

